import { LooseObject } from '../interface';

/**
 * Checks given variable if its a string and not empty.
 * @param {unknown} value The variable to be validated.
 * @returns {boolean} Value is valid or not.
 */
export const isNotEmptyString = (value: unknown): value is string => {
    return Boolean(value && 'string' === typeof value);
};

/**
 * Compares two objects to decide if they are deep equal or not.
 * @param {LooseObject=} obj1 Compare this...
 * @param {LooseObject=} obj2 ...with this.
 * @returns {boolean} Boolean
 */
export const areObjectsDeeplyEqual = (obj1?: LooseObject, obj2?: LooseObject) => {
    return (obj1 && obj2)
        ? JSON.stringify(obj1) === JSON.stringify(obj2)
        : Boolean(obj1) === Boolean(obj2);
};
